<div class="container">
  <nx-icon name="exclamation-circle-o" size="l"></nx-icon>

  <h1 nxHeadline class="nx-font-weight-bold">{{ '404: Page not found' | transloco }}</h1>

  <p>
    {{ 'The link you\'re trying to access is not found or expired.' | transloco }}<br />
    {{ 'Make sure the link is correct or contact your administrator if you think this is a mistake.' | transloco }}
  </p>
</div>
